<template>
<div class="inner-content m-b-xl">
{{/** case title wrapper */}}
  <div class="clearfix m-t-40 border-top">
    {{/** images */}}
    <div class="cas-img-wrp m-r-lg">
      <div class="cas-main-img img-c-div" v-bind:style='{ backgroundImage:"url("+images[activeImg]+")" }'></div>
      <div class="cas-s-img-wrp clearfix">
        <div @click="activeImg = index" v-for="(img, index) in images" :style="{backgroundImage: 'url('+img+')'}"></div>
      </div>
    </div>
    <div class="cas-img-wrp-next">
      <h3 class="cas-title-ct">{{cas.title}}</h3>
      <div :class="{'labels': labels.length < 1}">
        <div class="cas-tag-wrp">
          <span v-for="label in labels">{{label}}</span>
        </div>
      </div>
      <div class="cas-price-wrp">
        <!--<div class="price-top-wrp">-->
          <!--<span class="price-tag m-r" v-if="!isRealProduct">定金</span> <span class="price-header" v-if="!isRealProduct">{{cas.reservePrice/100}}</span>-->
          <!--<span class="price-tag m-r" v-if="isRealProduct">价格</span> <span class="price-header-normb" v-if="isRealProduct">{{cas.priceDesc}}</span>-->
          <!--<span class="price-tag m-r m-l-xl" v-if="!isRealProduct">总价</span> <span class="price-header" v-if="!isRealProduct">{{cas.sellPrice/100}}</span>-->
        <!--</div>-->
        <div class="cas-info clamp">{{cas.briefInfo?cas.briefInfo:cas.description}}</div>
        <div :class="{'promotion': cas.isPromotion !==2}">
          <div class="coupon m-t" v-if="cas.isPromotion ===2" style="margin-top: 20px">
            <img src="../assets/promo_icon.png"/>
            <span style="margin-left: 5px">
              {{cas.promotionInfo}}
            </span>
            <!--<div class="line-short m-t"></div>-->
        </div>
        </div>
      </div>
      <div class="cas-pay-wrap">
        <!--<router-link class="c-b c-b-book" type="button" :to="{name:'ShopDetail',params:{id: shop.id}}" >现在预定</router-link>-->
        <div>
          <button type="button" class="c-b c-b-book" @click="bookNow" v-if="!isRealProduct">现在预定</button>
          <button type="button" class="c-b c-b-book" @click="goBuy(cas.buyLink)" v-if="isRealProduct">去购买</button>
          <button type="button" class="c-b telInfo m-l-50" id="telInfo">{{telInfo}}</button>
          <!--<button type="button" class="c-b tel m-l-50">{{tel}}</button>-->
        </div>
        <div class="fav-area text-center" v-if="cas.isFavored" @click.stop="unFavorCaseInfo(cas)">
          <i class="fa fa-heart heart-pink"/>
          <span class="gray-1 text-small">收藏（{{cas.favorNum}}）</span>
        </div>
        <div class="fav-area text-center"  v-if="!cas.isFavored" @click.stop="favorCaseInfo(cas)">
          <i class="fa fa-heart-o" style="color: #a9a9a9;" />
          <span class="gray-1 text-small">收藏（{{cas.favorNum}}人气）</span>
        </div>
      </div>
    </div>
  </div>
  <div class="m-t-xl clearfix">
    {{/** 左边商家、商家相关案例、留言 */}}
    <div class="cas-shop-wrp">
      <div class="cas-shop-header">
        <div class="cas-shop-img img-c-div" :style="{backgroundImage: 'url('+shop.coverImgUrl+')'}"></div>
        <div class="m-t-md m-b-lg">
          {{shop.name}}
        </div>
        <!--<router-link class="c-b c-b-to-shop link-text" :to="{ name: 'ShopDeatil', params: { id: shop.id } }">进入店铺</router-link>-->
        <a @click="goToShop(shop.id)" class="c-b c-b-to-shop link-text">进入店铺</a>
      </div>
      <div class="cas-shop-infor b-gray-1 m-t-md">
        商家资讯
      </div>
      <div v-for="p in poster_list" class="related-cas clearfix" @click="goPosterDetail(p.uuid)">
        <div class="related-cas-img-div mg-style" v-bind:style="{backgroundImage: 'url(' + p.cover + ')'}"></div>
        <div class="related-cas-content">
          <div class="related-cas-header clamp-title">{{p.title.substring(0,22)}}</div>
          <div class="related-cas-desc">
            <span class="clamp" v-if="p.type !== 4 && p.content[0]">{{p.content[0].text.substring(0,24)}}</span>
            <span class="clamp" v-if="p.type === 4">{{p.content.text.substring(0,24)}}</span>
          </div>
        </div>
      </div>
      <form class="m-t-md b-gray-1" @submit.prevent="saveComment">
        <div class="cas-shop-infor">提交留言</div>
        <div class="p-a-md text-center">
          <textarea class="form-input" placeholder="请填写您的留言信息" v-model="comment"></textarea>
          <button :class="{'c-b c-b-to-shop m-t-md': true, 'disabled': !comment}" type="submit">提交</button>
        </div>
      </form>
    </div>
    <div class="cas-details b-gray-1">
      {{/** 右边案件详情 */}}
      <div v-sticky="{ zIndex: 12, stickyTop: -4 }">
        <div class="cas-details-tab">
          <span :class="{'active': activeDetailTag === 0}" @click="scrollTo('cas-detail-desc', 0)">案例概述</span><span
          :class="{'active': activeDetailTag === 2}" @click="scrollTo('cas-detail-picTxt' ,2)">图文详情</span><span
          :class="{'active': activeDetailTag === 1}" v-show="cas.priceScheme" @click="scrollTo('cas-detail-priceScheme' ,1)">费用解析</span>
        </div>
      </div>
      <div class="cas-details-content-wrp" id="cas-detail-desc">
        <div class="cas-details-header" v-if="cas.description">
          <span>婚礼概述</span>
        </div>
        <div class="cas-details-content text-prewarp" v-if="cas.description"><pre>{{cas.description}}</pre></div>
        <div class="cas-details-header" v-if="cas.themeDesc">
          <span>主题诠释</span>
        </div>
        <div class="cas-details-content m-t-20" v-if="cas.themeDesc"><pre>{{cas.themeDesc}}</pre></div>
        <div class="cas-details-header" v-if="cas.designDesc">
          <span>设计说明</span>
        </div>
        <div class="cas-details-content m-t-20" v-if="cas.designDesc">
          <pre>{{cas.designDesc}}</pre></div>
        <div class="cas-details-header" id="cas-detail-picTxt">
          <span>案例展示</span>
        </div>
        <template v-for="(txt, index) in picTxtJson">
          <template v-if="txt.type === 0">
            <div class="cas-details-header">
              <span>{{txt.txt}}</span>
            </div>
          </template>
          <template v-if="txt.type === 1">
            <div class="cas-details-content m-t-20"><pre>{{txt.txt}}</pre></div>
          </template>
          <template v-if="txt.type === 2" style="text-align: center">
            <img class="m-t-20" :src="txt.pic_url" style="width: 100%;">
          </template>
          <template v-if="txt.type === 3">
            {{/** 视频 */}}
            <p style="text-align: center"><iframe class="video_iframe" style="z-index:1;" :src="getTecentUrl(txt.video_url)" allowfullscreen="" frameborder="0" height="375" width="100%"></iframe></p>
          </template>
        </template>
        <div class="cas-details-header" v-if="cas.executeDesc">
          <span>执行心得</span>
        </div>
        <div class="cas-details-content m-t-20" v-if="cas.executeDesc">
          <pre>{{cas.executeDesc}}</pre></div>
        <div class="cas-details-header" v-if="cas.priceScheme" id="cas-detail-priceScheme">
          <span>价格参考</span>
        </div>
        <div class="cas-details-content" v-if="cas.priceScheme"><pre>{{cas.priceScheme}}</pre></div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import scrollToElement from 'scroll-to-element';
import VueSticky from 'vue-sticky';
import { videoPlayer } from 'vue-video-player';
import toastr from 'mini-toastr';
import service from '../service/apiHelper';
import uService from '../service/user';
import commentService from '../service/comment';
/* eslint-disable */
export default {
  name: 'CaseDetail',
  created() {
    service.getCaseInfo(this.$route.params.id).then((resp) => {
      this.cas = resp.data.case_info;
      this.shop = this.cas.shopInfo;
      this.tel = this.shop.telephone;
      this.poster_list = resp.data.poster_list;
    }, () => {
//      toastr.error(resp, '加载案件错误');
      this.$router.replace({ name: 'Index' });
    });
  },
  computed: {
    isRealProduct() {
      if (this.cas.type === 2) {
        return true;
      }
      return false;
    },
    picTxtJson() {
      return JSON.parse(this.cas.picTxtJson || '[]');
    },
    labels() {
      return JSON.parse(this.cas.labelList || '[]');
    },
    images() {
      const txt = JSON.parse(this.cas.picTxtJson || '[]');
      if (Array.isArray(txt)) {
        const arr = txt.filter(t => t.type === 2).filter((t, index) => index < 3).map(t => t.pic_url);
        if(arr.length === 0){
          arr.push(this.cas.coverImgUrl);
        }
        return arr;
      }
      return [];
    },
    videoOptions() {
      const txt = JSON.parse(this.cas.picTxtJson || '[]');
      if (Array.isArray(txt)) {
        return txt.map(t => ({
          sources: [{
            src: t.video_url,
          }],
        }));
      }
      return [];
    },
  },
  mounted() {
    const telInfoDom = document.getElementById('telInfo');
    telInfoDom.addEventListener('mouseover', (event) => {
      event.target.style.backgroundColor = '#ba882a';
      event.target.style.color = '#fff';
      this.telInfo = this.tel;
    });
    telInfoDom.addEventListener('mouseleave', (event) => {
      event.target.style.color = "#ba882a";
      event.target.style.backgroundColor = '#fff';
      this.telInfo = '联系电话';
    });
  },
  data() {
    return {
      cas: {
        reservePrice: 0.0,
        sellPrice: 0.0,
        favorNum: 0,
      },
      shop: {},
      poster_list: {},
      activeImg: 0,
      activeDetailTag: 0,
      comment: undefined,
      tel: undefined,
      telInfo: '联系电话',
    };
  },
  methods: {
    saveComment() {
      const user = uService.getUser();
      if (!user || !user.telephone) {
        this.$router.push({ name: 'Login' });
        toastr.error('登录后才能留言');
        return;
      }
      const comment = {
        content: this.comment,
        shop_id: this.shop.id,
        case_id: this.cas.id,
        telephone: user.telephone,
      };
      commentService.add(comment).then(() => {
        this.comment = '';
        toastr.success('留言成功');
      }, () => {
        toastr.error('留言失败');
      });
    },
    scrollTo(el, index) {
      this.activeDetailTag = index;
      const options = {
        easing: 'linear',
        offset: -60,
      };
      scrollToElement(`#${el}`, options);
    },
    bookNow() {
//      toastr.success('暂未开放');
      // 需要登录
      const user = uService.getUser();
      if (!user || !user.telephone) {
        this.$router.push({ name: 'Login' });
        toastr.error('登录后才能预定');
        return;
      }
      this.$router.push({ name: 'Pay', params: { id: this.$route.params.id } });
    },
    goPosterDetail(id) {
//      this.$router.push({ name: 'NewsDetail', params: { id } });
      window.open(`#/NewsDetail/${id}`);
    },
    goBuy(url) {
      window.open(url);
    },
    goToShop(id) {
      window.open(`#/ShopDetail/${id}`);
    },
    getTecentUrl(vid) {
      return `http://v.qq.com/iframe/player.html?vid=${vid}&auto=0`;
    },
    favorCaseInfo(caseInfo) {
      if (!uService.hasLogin()) {
        toastr.error('请登录后收藏');
        return;
      }
      service.favorCase(caseInfo.id).then(() => {
        this.$set(caseInfo, 'isFavored', true);
        const newFavorNum = caseInfo.favorNum + 1;
        this.$set(caseInfo, 'favorNum', newFavorNum);
      });
    },
    unFavorCaseInfo(caseInfo) {
      if (!uService.hasLogin()) {
        toastr.error('请登录后取消收藏');
        return;
      }
      service.unFavorCase(caseInfo.id).then(() => {
        this.$set(caseInfo, 'isFavored', false);
        const newFavorNum = caseInfo.favorNum - 1;
        this.$set(caseInfo, 'favorNum', newFavorNum);
      });
    },
  },
  components: {
    videoPlayer,
  },
  directives: {
    sticky: VueSticky,
  },
};
</script>
<style scoped>
.cas-img-wrp {
  width: 320px;
  float: left;
}
.cas-main-img {
  width: 100%;
  height: 240px;
}
.cas-s-img-wrp {
  margin-top: 20px;
}
.cas-s-img-wrp div {
  width: calc(33.33% - 10px);
  margin-right: 15px;
  background-position: center;
  background-size: cover;
  padding-top: calc(33.33% - 10px);
  cursor: pointer;
  float: left;
}
.cas-s-img-wrp div:last-child {
  margin-right: 0;
}
.cas-title-ct {
  font-size: 22px;
  margin-top: 0;
  margin-bottom: 16px;
  color: #252525;
}
.cas-tag-wrp {
  margin-right: -24px;
  color: #a9a9a9;
  font-size: 12px;
  line-height: 26px;
}
.cas-tag-wrp > span {
  border-radius: 2px;
	border: solid 1px #f3f3f3;
  margin-right: 24px;
  padding: 3px 9px;
}
.cas-price-wrp {
  color: #df3a4e;
  margin-top: 35px;
  line-height: 42px;
}
.price-tag {
  font-size: 12px;
  color: #df3a4e;
  border-radius: 2px;
	border: solid 1px #df3a4e;
  padding: 3px 10px;
}
.price-header-normb {
  color: #df3a4e;
  font-size: 30px;
  font-weight: 400;
}
.price-header {
  color: #df3a4e;
  font-size: 30px;
  font-weight: 400;
}
.cas-price-wrp > span {
  vertical-align: middle;
}
.price-header::before {
  content: '¥';
  font-size: 14px;
}
.price-top-wrp{
  background: #f3f3f3;
  height: 45px;
  width: 445px;
  line-height: 42px;
  padding-left: 15px;
}
.cas-info{
  height: 84px;
  width: 90%;
  /*padding-left: 15px;*/
  color: #787878;
  font-size: 14px;
  line-height: 28px;
}
.price-top-wrp span{
  vertical-align: middle;
}
.coupon {
  font-size: 14px;
  line-height: 40px;
}
.coupon img{
  width: 20px;
  height: 20px;
  object-fit: contain;
  vertical-align: middle;
}
.coupon span{
  vertical-align: middle;
}
.cas-img-wrp-next {
  margin-left: 380px;
}
.cas-shop-wrp {
  width: 280px;
  float: left;
}
.cas-shop-header {
  border: solid 1px #e1e1e1;
  padding: 30px;
  text-align: center;
  font-size: 16px;
  color: #252525;
}
.cas-details {
  margin-left: 320px;
}
.cas-shop-img {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background-color: #d7d7d7;
  margin: 0 auto;
}
.cas-shop-infor {
  background-color: #f6f6f6;
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  color: #252525;
  text-align: center;
}
.related-cas {
  padding: 20px 0;
  border-bottom: 1px dashed #e1e1e1;
}
.related-cas-img-div {
  float: left;
  width: 130px;
  height: 80px;
}
.mg-style{
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.related-cas-content {
  margin-left: 140px;
}
.related-cas-header {
  color: #525252;
  font-size: 14px;
  line-height: 1.4;
}
.related-cas-desc {
  color: #787878;
  font-weight: 300;
  line-height: 1.4;
  font-size: 12px;
  margin-top: 10px;
}
.cas-details-tab {
  height: 60px;
  line-height: 60px;
  background-color: #f6f6f6;
	border-bottom: solid 1px #e3e3e3;
  font-size: 18px;
}
.cas-details-tab > span {
  display: inline-block;
  height: 100%;
  padding: 0 38px;
  border-right: 1px solid #e5e5e5;
  vertical-align: middle;
  cursor: pointer;
}
.cas-details-tab > span.active {
  background: #fff;
  border-top: 4px solid #ba882a;
  height: 58px;
}
.cas-details-content-wrp {
  padding: 15px 50px;
}
.cas-details-content-wrp > img {
  max-width: 100%;
  width: auto;
  height: auto;
}
.cas-details-header {
  padding: 10px 0 10px 0;
  border-bottom: 1px dashed #c1c1c1;;
}
.cas-details-header > span {
  border-left: 4px solid #ba882a;
  padding-left: 15px;
}
.cas-details-content {
  font-size: 14px;
  color: #787878;
  line-height: 2.14;
}
.img-c-div {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
pre{
  word-wrap: break-word;
  white-space: pre-wrap;
}
.border-top{
  /*border: solid 1px #e1e1e1;*/
  padding: 15px;
}
.line-short{
  width: 460px;
  height: 1px;
  background-color: #e1e1e1;
}
.fav-area{
  display: inline-block;
  cursor: pointer;
  /*margin-left: 59px;*/
  margin-top: 21px;
}
.fav-area i{
  font-size: 14px;
}
.fav-area span{
  color: #a9a9a9;
  font-size: 14px;
}
.clamp-title {
  word-break:break-all;
  display:-webkit-box;
  -webkit-line-clamp:1;
  text-overflow: ellipsis;
  -webkit-box-orient:vertical;
  overflow:hidden;
}
.clamp {
  word-break:break-all;
  display:-webkit-box;
  -webkit-line-clamp:3;
  text-overflow: ellipsis;
  -webkit-box-orient:vertical;
  overflow:hidden;
}
.m-l-50 {
  margin-left: 50px;
}
.telInfo{
  border-radius: 2px;
  border: solid 1px #ba882a;
  height: 50px;
  padding: 11px 35px;
  font-size: 20px;
  color: #ba882a;
  width: auto;
  background-color: #fff;
}
.cas-pay-wrap {
  margin-top: 25px;
}
.promotion {
  height: 20px;
  margin-top: 34px;
}
.labels {
  height: 23px;
  margin-top: 13px;
}
.m-t-40 {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// CaseDetail.vue?f4e68f1c